import React from 'react';
import { observer } from 'mobx-react-lite';
import { getAmountWithCurrency } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { betDataStore, oddStore } from '../../../../store';

export const CurrentWinAmount = observer(({ gameTypeId }) => {
  const { betAmount } = betDataStore.betsSectionsData[gameTypeId];
  const currentWinAmount = oddStore.currentWinAmount;
  const { minBet, maxBet } = gameConfigStore.limits;

  const amount =
    +currentWinAmount[gameTypeId] ||
    (+betAmount < minBet ? minBet : +betAmount > maxBet ? maxBet : +betAmount);

  return (
    <div className='pascal-game-col-bottom-amount'>
      <span className='pascal-game-col-bottom-count'>
        {getAmountWithCurrency({
          amount: amount.toFixed(2),
        })}
      </span>
    </div>
  );
});
